import { Controller } from 'stimulus';

export default class extends Controller {
  search({ target }) {
    const { form } = target;
    form.submit();
  }
}
